import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type {
  ActivityFeedGroup,
  ActivityFeedParams,
  ActivityFeedResponse,
  ActivityHeatmapResponse,
  ActivityType,
} from '@/types/activity'

interface ApiWrapper<T> {
  success: boolean
  message?: string
  data: T
}

interface FeedMeta {
  from: string
  to: string
  next_cursor: string | null
  has_more: boolean
}

export const activityApi = {
  /** Лента событий с курсорной пагинацией; date — детализация одного дня */
  feed: async (params: ActivityFeedParams = {}): Promise<ActivityFeedResponse> => {
    const response = await apiClient.get<ApiWrapper<ActivityFeedGroup[]> & { meta: FeedMeta }>(
      API_ENDPOINTS.USER_ACTIVITY,
      {
        params: {
          user_id: params.userId,
          scope: params.scope,
          date: params.date,
          from: params.from,
          to: params.to,
          types: params.types?.length ? params.types : undefined,
          per_page: params.perPage,
          cursor: params.cursor ?? undefined,
        },
      },
    )

    return {
      groups: response.data.data,
      from: response.data.meta.from,
      to: response.data.meta.to,
      next_cursor: response.data.meta.next_cursor,
      has_more: response.data.meta.has_more,
    }
  },

  /** Тепловая карта; с types[] считается из журнала активности */
  heatmap: async (options: {
    userId?: number
    range?: 'year' | 'half_year' | 'quarter'
    types?: ActivityType[]
  } = {}): Promise<ActivityHeatmapResponse> => {
    const response = await apiClient.get<ApiWrapper<ActivityHeatmapResponse>>(
      API_ENDPOINTS.DASHBOARD.HEATMAP,
      {
        params: {
          user_id: options.userId,
          range: options.range,
          types: options.types?.length ? options.types : undefined,
        },
      },
    )
    return response.data.data
  },
}
